import { CommonModule } from '@angular/common';
import { Component, NgModule, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ValidationCallbackData } from 'devextreme-angular/common';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import { Subscription } from 'rxjs';
import { AuthService, IResponse } from 'src/app/services';

@Component({
	selector: 'two-factor-code-form',
	templateUrl: './two-factor-code-form.component.html',
	styleUrls: ['./two-factor-code-form.component.scss'],
})
export class TwoFactorCodeFormComponent implements OnInit {
	private _router: Router;

	@Input() buttonLink = '/';

	loading = false;

	formData: any = {};

	constructor(
		private authService: AuthService, 
		router: Router,
	) { 
		this._router = router;
	}

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
	}

	async onSubmit(e: Event) {
		e.preventDefault();

		const { twoFactorCode } = this.formData;

		this.loading = true;
		const result = await this.authService.logInTfc(twoFactorCode);
		this.loading = false;

		if (result.isOk) {
			this._router.navigate([this.buttonLink]);
		} else {
			notify(result.message, 'error', 2000);
			this._router.navigate(['/auth/login']);
		}
	}
}
@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		DxFormModule,
		DxLoadIndicatorModule,
	],
	declarations: [TwoFactorCodeFormComponent],
	exports: [TwoFactorCodeFormComponent],
})
export class TwoFactorCodeFormModule { }
